module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/common-module/components/expandable-block/expandable-block.component.scss
// module id = ./src/app/modules/common-module/components/expandable-block/expandable-block.component.scss
// module chunks = 9